function getConfig(name, defaultValue = null) {
    // If inside a docker container, use window.ENV
    if (window.ENV !== undefined) {
        return window.ENV[name] || defaultValue;
    }

    return process.env[name] || defaultValue;
}

export function getBackendUrl() {
    let url = getConfig('REACT_APP_BACKEND_URL');
    
    // Se não houver URL configurada, usar o mesmo host do navegador na porta 8080
    if (!url) {
        if (typeof window !== 'undefined' && window.location) {
            const proto = window.location.protocol;
            const host = window.location.hostname;
            return `${proto}//${host}:8080`;
        }
        return 'http://localhost:8080';
    }

    // Auto-correção: se for http://localhost ou http://127.0.0.1 sem porta, adicionar :8080
    if (url === 'http://localhost' || url === 'http://127.0.0.1') {
        url = 'http://localhost:8080';
    }

    // Se o frontend está sendo acessado por um IP/domínio remoto no navegador,
    // mas a URL configurada ainda aponta para localhost, substituir pelo hostname atual do navegador
    if (typeof window !== 'undefined' && window.location) {
        const clientHost = window.location.hostname;
        if (clientHost && clientHost !== 'localhost' && clientHost !== '127.0.0.1') {
            if (url.includes('localhost') || url.includes('127.0.0.1')) {
                url = url.replace(/localhost|127\.0\.0\.1/, clientHost);
            }
        }
    }

    return url;
}

export function formatMediaUrl(url) {
    if (!url) return null;
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    const backendUrl = getBackendUrl() || '';
    const cleanBackendUrl = backendUrl.endsWith('/') ? backendUrl.slice(0, -1) : backendUrl;
    const cleanUrl = url.startsWith('/') ? url : `/${url}`;
    return `${cleanBackendUrl}${cleanUrl}`;
}



